export default __webpack_public_path__ + "static/media/apple-chomp.c98feb61.mp3";